/* eslint-disable consistent-return */
import keyCode from "utils/keycode"

export function translate(event) {
  if (event.keyCode === keyCode.J && (event.metaKey || event.ctrlKey)) {
    return "down"
  } else if (event.keyCode === keyCode.K && (event.metaKey || event.ctrlKey)) {
    return "up"
  } else if (event.keyCode === keyCode.ENTER) {
    event.nativeEvent.preventDefault()
    return "enter"
  } else if (event.keyCode === keyCode.UP) {
    event.nativeEvent.preventDefault()
    return "up"
  } else if (event.keyCode === keyCode.DOWN) {
    event.nativeEvent.preventDefault()
    return "down"
  } else if (event.keyCode === keyCode.ESC) {
    return "escape"
  }
}

export function isLetter(event) {
  return event.keyCode >= 65 && event.keyCode <= 90
}

export default { translate }
